import { createContext } from 'react';

export const I18nContext = createContext({
  locale: '',
  t: (s: string) => s,
  supportedLocales: [] as string[],
});
